import React, { useState, memo, useMemo, useCallback } from "react"

import { useCore } from "../../../hooks/useCore"
import { useImage } from "../../../hooks/useImage"

export const withCartDonationItem = Component =>
  memo(({ name = "CartDonationItem", donationTitle, donationContent, donationImage }: any) => {
    const {
      helpers: { sanityContent },
    } = useCore()
    const { getFluidImage } = useImage()

    const [display, setDisplay] = useState(true)

    const content = sanityContent(donationContent)
    const image = getFluidImage(donationImage, { maxWidth: 500 })

    const handleRemove = useCallback(() => {
      setDisplay(!display)
    }, [display, setDisplay])

    Component.displayName = name
    return useMemo(
      () => <Component display={display} donationTitle={donationTitle} donationContent={content} donationImage={image} handleRemove={handleRemove} />,
      [display, donationTitle, content, image, handleRemove]
    )
  })
